/**
 * Pfade OHNE Sprachpräfix: die Verwaltung (`/admin/…`) und das Berater-Dashboard
 * (`/advisor/…`). Sie stehen in `App.jsx` flach, nicht unter `/{land}/{sprache}`.
 *
 * Ein Sprachwechsel auf einer solchen Seite ändert deshalb nur Sprache und
 * Cookie, nicht die Adresse. Bis 20.10.2026 baute `useLanguage` auch hier
 * `/{land}/{sprache}/admin/users` — eine Adresse, die es nicht gibt (404).
 */
export const GLOBALE_PFADE = ['/admin', '/advisor'] as const

export function istGlobalerPfad(pathname: string): boolean {
  return GLOBALE_PFADE.some((praefix) => pathname === praefix || pathname.startsWith(`${praefix}/`))
}
